export default __webpack_public_path__ + "static/media/start.1681cbbc.mp3";